import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Projekte } from './pages/Projekte';
import { About } from './pages/About';
import { CookieBanner } from './components/CookieBanner';
type AccentPalette = 'violet' | 'signal';
type AppProps = {
  accent?: AccentPalette;
};
export function App({
  accent = 'violet'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2rl6vf6ijosua">
      <Routes data-id="element-1" data-mp="2rikmb2g0a59y">
        <Route path="/" element={<Home accent={accent} data-id="element-3" data-mp="2mmlvl877gb6d" />} data-id="element-2" data-mp="2mm2m8fvmev3y" />
        <Route path="/projekte" element={<Projekte accent={accent} data-id="element-5" data-mp="31aqf2ee30qq7" />} data-id="element-4" data-mp="2mnnhy8to8k3e" />
        <Route path="/ueber-mich" element={<About accent={accent} data-id="element-7" data-mp="31ctdnmtavs6j" />} data-id="element-6" data-mp="31brzvakwgrl4" />
        <Route path="/:slug" element={<Legal accent={accent} data-id="element-9" data-mp="2wj8cxn0bok3n" />} data-id="element-8" data-mp="2wjgqlh49rtfw" />
      </Routes>
      <CookieBanner data-id="element-10" data-mp="28ufqch5lbolp" />
    </BrowserRouter>;
}